import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Ghost, Home, Car } from "lucide-react";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md text-center">
        <div className="w-16 h-16 bg-red-500 rounded-xl flex items-center justify-center mx-auto mb-6">
          <Ghost className="w-8 h-8 text-white" />
        </div>
        
        <h1 className="text-4xl font-bold text-gray-900 mb-2">404</h1>
        <h2 className="text-xl font-semibold text-gray-700 mb-4">Page Not Found</h2>
        <p className="text-gray-600 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>

        <div className="space-y-4">
          <Link to="/">
            <Button className="w-full bg-blue-600 hover:bg-blue-700 text-white">
              <Home className="w-4 h-4 mr-2" />
              Go Back Home
            </Button>
          </Link>
          
          <Link to="/booking">
            <Button variant="outline" className="w-full border-gray-200 hover:bg-gray-50">
              <Car className="w-4 h-4 mr-2" />
              Book a Wash
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
